<template>
  <AppTooltip v-if="shouldDisplayButton" eager>
    <template #activator="{ props }">
      <app-button class="document-duplicate-button"
                  size="small"
                  type="icon"
                  v-bind="props"
                  @click="onDuplicate"
      >
        <app-material-icon name="content_copy"/>
      </app-button>
    </template>
    <span>
      {{ $t(`${TRANSLATION_KEY_PREFIX}.tooltip`) }}
    </span>
  </AppTooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'
import { track } from '@/common/pendo/agent'
import { getFileExtension, isFileLowerThanMaxSignableSize } from '@/common/utils/files'
import {
  getOfficeDocumentType,
  OFFICE_EDITION_MAX_FILE_SIZE,
  type SupportedOfficeDocumentTypes,
} from '@/common/utils/office'

const TRANSLATION_KEY_PREFIX = 'common.document-versioning.DocumentVersioningWopiDuplicationButton'

export default defineComponent({
  name: 'DocumentVersioningWopiDuplicationButton',
  components: { AppTooltip },
  emits: ['duplicate'],
  props: {
    document: {
      type: Object,
      required: true,
    },
    duplicationAvailable: {
      type: Boolean,
    },
  },
  data () {
  return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    shouldDisplayButton (): boolean {
      return this.officeDocumentType && this.duplicationAvailable && this.isDocumentSizeUnderOfficeEditionLimit && this.document['isUserFromSub']
    },
    isDocumentSizeUnderOfficeEditionLimit (): boolean {
      if (!this.officeDocumentType) {
        return true
      }

      const editionMaxFileSize = OFFICE_EDITION_MAX_FILE_SIZE[this.officeDocumentType]
      return isFileLowerThanMaxSignableSize(this.document, editionMaxFileSize)
    },
    officeDocumentType (): SupportedOfficeDocumentTypes | null {
      const fileExtension = getFileExtension(this.document)

      if (!fileExtension) {
        return null
      }

      return getOfficeDocumentType(fileExtension)
    },
  },
  methods: {
    onDuplicate () {
      track('duplicate_M365_document', { type: this.officeDocumentType })
      this.$emit('duplicate')
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.document-duplicate-button {
  height: 28px !important;
  min-width: 28px !important;
  border: get-border();
  padding: 4px !important;
}
</style>
